import TripItemTaxi from './trip-item-taxi';
import TripItemTaxiService from './trip-item-taxi-service';

import './trip-item-taxi.scss';

const MODULE_NAME = 'app.trip.item-taxi';
const module = angular.module(MODULE_NAME, [])
    .directive(TripItemTaxi.DIRECTIVE_NAME, TripItemTaxi)
    .service(TripItemTaxiService.SERVICE_NAME, TripItemTaxiService);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/trip/trip-item-taxi/trip-item-taxi-module.js